import React from 'react';
import styled from 'styled-components';

import languageHelper from '../../../utils/language/language-helper';
import { stepHeaderCounterLabel } from '../../../utils/language/wizard-labels';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { ButtonLabel } from '../../../styles/generic';

interface Props {
  currentStep: number;
  maxAmountOfSteps: number;
}

const StepCounter = ({ currentStep, maxAmountOfSteps }: Props) => {
  const percentage = ((currentStep || 0) / maxAmountOfSteps) * 100;
  const { lang } = languageHelper();

  return (
    <Container data-testid="step-counter">
      <Text data-testid="step-copy">
        {stepHeaderCounterLabel(currentStep, maxAmountOfSteps).counter[lang]}
      </Text>
      <ProgressContainer>
        <ProgressBar amount={percentage} data-testid="progress-bar" />
      </ProgressContainer>
    </Container>
  );
};

export default StepCounter;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${mq.from.breakpoint.M`
    gap: 0;
  `}
`;

const Text = styled.span`
  ${ButtonLabel};
  color: ${({ theme }) => theme.colors.abnGreen300};
  font-family: ${({ theme }) => theme.fontRegular};
  text-align: right;

  ${mq.from.breakpoint.M`
    position: relative;
    top: -22px;
  `}
`;

const ProgressContainer = styled.div`
  background: ${Colors.white};
  height: 4px;
  width: 100%;
`;

const ProgressBar = styled.div<{ amount: number }>`
  background: ${({ theme }) => theme.colors.abnGreen400};
  height: 4px;
  width: ${({ amount }) => amount}%;
`;
